import { scope } from "../../utils/customHelperFunctions";
const { hasLength } = scope;
interface formatQuantityI {
    custom_quantity: string | number
    locations: any[]
    shopify_quantity: string | number
    inventory_management: string,
    inventory_policy: string,
    profile_info?: any,
    props: any,
    defaultSettings?: any,
    inventory_settings: boolean,
    continue_selling: {
        enabled: boolean,
        value: string
    },
    effective_inventory: {
        enabled: boolean,
        type: string,
        value: string,
    },
    inactivate_product: boolean,
}

export function getWarehouseIdSelecte(profileInfo: any) {
    let warehouseSelect: any[] = [];
    profileInfo?.forEach((ele: any) => {
        if (ele['data_type'] == 'inventory_settings') {
            warehouseSelect = ele['data']['warehouses'];
        }
    });
    return warehouseSelect;
}

export function formatDefaultSetting(default1: any[]) {
    let warehouseSelect: any[] = [];
    default1 && default1.forEach((ele) => {
        if (ele['key'] == 'inventory') {
            warehouseSelect = ele['value']['warehouses'];
        }
    })
    return warehouseSelect;
}

export function filterNonAcitveWarehouse(warehousesSelected: any[], allWarehouseInfo: any[]) {
    let obj: any = {};
    let warehouseToShow: any[] = [];
    let activeWarehouseCounter: number = 0;
    let singleWarehouseId = '';

    allWarehouseInfo?.forEach((ele: any) => {
        if (ele.active) {
            activeWarehouseCounter++;
            singleWarehouseId = ele.id
        }
        obj[ele.id] = ele.active;
    })
    if (activeWarehouseCounter == 1) {
        // this condition handle the case when only 1 warehouse is checked, so by default we show the value of that warehouse
        warehouseToShow.push(singleWarehouseId);
    } else {
        if (Array.isArray(warehousesSelected)) {
            warehousesSelected?.forEach((ele) => {
                if (obj[ele]) {
                    warehouseToShow.push(ele);
                }
            });
        }
        else if (warehousesSelected == "all") {
            warehouseToShow = Object.keys(obj);
        }
    }
    return warehouseToShow;
}

export function formatQuantityExtended(params: formatQuantityI) {
    let warehouseSelect = filterNonAcitveWarehouse(params['profile_info'] ? getWarehouseIdSelecte(params['profile_info']) : formatDefaultSetting(params['defaultSettings']), params?.props?.redux?.current?.source?.warehouses);
    let { locations, shopify_quantity, inventory_management, inventory_policy, custom_quantity, continue_selling, effective_inventory } = params;
    let inventory: any = {
        value: 0,
        setting_found: false,
        label: 'Calculated Inventory',
        shopify_quantity
    };
    let temp_locations: any = 0;
    if (params?.['inventory_settings']) {
        if ((inventory_management && inventory_policy && inventory_policy?.toLowerCase() === 'continue' && continue_selling?.enabled) || (!inventory_management && continue_selling?.enabled)) {
            inventory['value'] = continue_selling?.value ?? 999;
            inventory['setting_found'] = true;
        }
        else {
            if (custom_quantity) {
                inventory['value'] = custom_quantity;
                // inventory['setting_found'] = true;
            }
            else {
                /* code for selected warehouse/locations */
                if (hasLength(locations)) {
                    locations?.forEach((loc: any) => {
                        if (warehouseSelect.includes(loc.location_id))
                            temp_locations += loc?.['available'];
                    });
                    if (effective_inventory?.enabled && effective_inventory?.type == 'threshold') {
                        if (+effective_inventory?.value > temp_locations) {
                            inventory['value'] = 0;
                        }
                        else {
                            inventory['value'] = temp_locations;
                        }
                    }
                    else {
                        if (effective_inventory?.enabled && effective_inventory?.type == 'reserved') {
                            inventory['value'] = temp_locations - +effective_inventory['value'];
                            inventory['setting_found'] = true;
                        }
                        else if (effective_inventory?.enabled && effective_inventory?.type == 'fixed') {
                            inventory['value'] = +effective_inventory['value'];
                            inventory['setting_found'] = true;
                        }
                        else {
                            inventory['value'] = temp_locations;
                        }
                    }
                    // make inv zero if calculated inv becomes negative
                    if (inventory['value'] < 0) inventory['value'] = 0;
                } else {
                    inventory['value'] = shopify_quantity;
                }
            }
        }
    }
    else {
        inventory['value'] = shopify_quantity;
    }

    return inventory;
}

export function formatQuantity(params: formatQuantityI) {
    let warehouseSelect = filterNonAcitveWarehouse(params['profile_info'] ? getWarehouseIdSelecte(params['profile_info']) : formatDefaultSetting(params['defaultSettings']), params?.props?.redux?.current?.source?.warehouses);
    let { locations, shopify_quantity, inventory_management, inventory_policy, custom_quantity, continue_selling, effective_inventory } = params;
    let inventory: any = {
        value: 0,
        setting_found: false,
        label: 'Calculated Inventory',
        shopify_quantity
    };
    let temp_locations: any = 0;
    if (params?.['inventory_settings']) {
        if ((inventory_management && inventory_policy && inventory_policy?.toLowerCase() === 'continue' && continue_selling?.enabled) || (!inventory_management && continue_selling?.enabled)) {
            inventory['value'] = continue_selling?.value ?? 999;
            inventory['setting_found'] = true;
        }
        else {
            if (custom_quantity) {
                inventory['value'] = custom_quantity;
                // inventory['setting_found'] = true;
            }
            else {
                /* code for selected warehouse/locations */
                if (hasLength(locations)) {
                    locations?.forEach((loc: any) => {
                        if (warehouseSelect.includes(loc.location_id))
                            temp_locations += loc?.['available'];
                    });
                    if (effective_inventory?.enabled && effective_inventory?.type == 'threshold') {
                        if (+effective_inventory?.value > temp_locations) {
                            inventory['value'] = 0;
                        }
                        else {
                            inventory['value'] = temp_locations;
                        }
                    }
                    else {
                        if (effective_inventory?.enabled && effective_inventory?.type == 'reserved') {
                            inventory['value'] = temp_locations - +effective_inventory['value'];
                            inventory['setting_found'] = true;
                        }
                        else if (effective_inventory?.enabled && effective_inventory?.type == 'fixed') {
                            inventory['value'] = +effective_inventory['value'];
                            inventory['setting_found'] = true;
                        }
                        else {
                            inventory['value'] = temp_locations;
                        }
                    }
                    // make inv zero if calculated inv becomes negative
                    if (inventory['value'] < 0) inventory['value'] = 0;
                } else {
                    inventory['value'] = shopify_quantity;
                }
            }
        }
    }
    else {
        inventory['value'] = shopify_quantity;
    }

    return inventory;
}
